import { unescape } from "lodash";
import React, { useEffect, useMemo, useState } from "react";

type RewardsData = {
  rewards_text: string | null
  rewards_enabled: boolean
} | null

const getRewards = (): RewardsData => {
  try {
    const rewards = JSON.parse(document.querySelector("[data-rewards]")?.innerHTML);

    if (rewards) return rewards;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const CartRewards: React.FC = () => {
  const [rewardsData, setRewardsData] = useState<RewardsData>(null)

  const unescapedText = useMemo(
    () => rewardsData?.rewards_text ? unescape(rewardsData.rewards_text) : ""
    , [rewardsData?.rewards_text])

  useEffect(() => {
    setRewardsData(getRewards())
  }, [])

  return rewardsData?.rewards_enabled && unescapedText?.length ? <div className="cart__rewards" dangerouslySetInnerHTML={{ __html: unescapedText }} /> : null
}